import dept from './dept';
import user from './user';
import post from './post';
import role from './role';
import menu from './menu';

export default {
    organization: { routerName: '組織管理' },
    ...dept,
    ...user,
    ...post,
    ...role,
    ...menu,
};
